import React from "react";
import { Route } from "react-router-dom";
import { ProtectedRoute } from "../hooks/rute/ProtectedRoute";
import { ProtectedRoleAccountManager } from "../hooks/roles/ProtectedRoleAccountManager";
import { LazySuspense } from "../components/layout/AppHeader/lazySuspense";
const ErrorPage = React.lazy(() => import("../components/error-page"));
const TaskClient = React.lazy(() => import("../screean/task/taskClient"));
export function tareasCliente() {
  return (
    <Route
      path="/tareas-cliente"
      element={
        <LazySuspense>
          <ProtectedRoute>
            <ProtectedRoleAccountManager>
              <TaskClient />
            </ProtectedRoleAccountManager>
          </ProtectedRoute>
        </LazySuspense>
      }
      errorElement={
        <LazySuspense>
          <ErrorPage />
        </LazySuspense>
      }
    />
  );
}
